import React, { Component } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Radio, Modal, Input, InputNumber, Icon, Button, message,Tooltip } from 'antd'
import SelectRetail from '@/components/SelectRetail'
import * as apis from '@/apis'
import moment from 'moment'
import styles from './bindReferral.module.scss'
import {
  QuestionCircleOutlined,
} from '@ant-design/icons';
const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 15 },
}

@Form.create()
class CreateModal extends Component {
  state = {
    loading: false,
    tab: 1
  }

  handleSubmit = e => {
    const { onSuccess, referral, successCallback } = this.props
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }
      // if (values.per_order_commission_rate) {
      //   values.per_order_commission_rate = Number(values.per_order_commission_rate) / 100

      //   if (Number.isNaN(values.per_order_commission_rate)) {
      //     return message.error('请输入正确数值')
      //   }
      // }

      // if (values.per_order_commission) {
      //   values.per_order_commission = Number(values.per_order_commission)
      //   if (Number.isNaN(values.per_order_commission)) {
      //     return message.error('请输入正确数值')
      //   }
      // }

      apis.bindRetailReferral(referral._id, values)
        .then(result => {
          message.success('添加成功')
          onSuccess(result)
          successCallback && successCallback(result)
        })
        .catch(error => {
          message.error(error.message || '添加失败')
        })
    });
  }

  normalizeRetail = (value, prevValue, allValues) => {
    if (typeof value === 'string') {
      return value
    }

    if (value && value._id) {
      return value._id
    }

    return null
  }

  render() {
    const { tenant } = this.props
    const { getFieldDecorator, validateFields, getFieldValue } = this.props.form
    const data = {}
    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">上传</div>
      </div>
    )

    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <Form.Item
            {...formItemLayout}
            label="散户"
            required>
            {getFieldDecorator('retail', {
              normalize: this.normalizeRetail,
              rules: [
                {
                  required: true,
                  message: '请选择散户',
                },
              ],
            })(
              <SelectRetail placeholder="输入散户名称" />
            )}
          </Form.Item>
          {/* <Form.Item
            {...formItemLayout}
            label="结算类型"
            required>
            {getFieldDecorator('type', {
              initialValue: 1,
              rules: [
                {
                  required: true,
                  message: '请选择结算类型',
                },
              ],
            })(
              <Radio.Group>
                <Radio value={1}>每单固定金额</Radio>
                <Radio value={2}>每单毛利分成
                <Tooltip placement="top" title="订单毛利=订单总价-师傅工费（注：订单总价和师傅工费都包含申诉、调价的费用）"><QuestionCircleOutlined style={{marginLeft:5}}/></Tooltip></Radio>
              </Radio.Group>
            )}
          </Form.Item>
          {
            getFieldValue('type') === 1 && (
              <Form.Item
                {...formItemLayout}
                label="每单金额"
                required>
                {getFieldDecorator('per_order_commission', {
                  rules: [
                    {
                      required: true,
                      message: '请输入每单金额',
                    },
                  ],
                })(
                  <div>
                    <Input
                      prefix="￥"
                      suffix="元" 
                      style={{width: 110}} />
                  </div>
                )}
              </Form.Item>
            )
          }
          {
            getFieldValue('type') === 2 && (
              <Form.Item
                {...formItemLayout}
                label="分成比例"
                required>
                {getFieldDecorator('per_order_commission_rate', {
                  rules: [
                    {
                      required: true,
                      message: '请输入每单毛利分成比例',
                    },
                  ],
                })(
                  <div>
                    <InputNumber
                      style={{width: 80}}
                      precision={0} 
                      min={1}
                      max={100} />
                    <span style={{marginLeft: 5}}>%</span>
                    
                  </div>
                  
                )}
              </Form.Item>
            )
          } */}
          <div className={styles.footer}>
            <Button type="primary" htmlType="submit">
              添加
            </Button>
          </div>
        </Form>
      </div>
    )
  }
}

const RetailInfoDialog = ({
  modal: {
    name,
  },
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => {
  return (
    <Modal
      title={ownProps.title}
      destroyOnClose
      footer={null}
      width={460}
      style={{ top: 30 }}
      visible={isOpen}
      onCancel={hide}>
      <CreateModal onSuccess={submit} {...ownProps} />
    </Modal>
  )
}

export default sagaModal({
  name: 'RETAIL_REFERRALS_BINDING_DIALOG',
 })(RetailInfoDialog)
